import { Shield, CreditCard, Truck, Infinity, Wifi, MessageCircle } from "lucide-react";

const trustItems = [
  { icon: Infinity, label: "À VIE", sub: "Sans abonnement" },
  { icon: Shield, label: "Garantie 30j", sub: "Satisfait ou remboursé" },
  { icon: CreditCard, label: "Paiement sécurisé", sub: "Stripe SSL" },
  { icon: Truck, label: "Livraison offerte", sub: "Dès 80€ d'achat" },
];

interface TrustSectionProps {
  productId?: string;
  price?: number;
}

export const TrustSection = ({ productId, price = 89 }: TrustSectionProps) => {
  const formatPrice = (n: number) => new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR" }).format(n);

  return (
    <section className="py-12 md:py-16 bg-secondary/40 px-4">
      <div className="max-w-4xl mx-auto text-center space-y-8">
        <div className="space-y-2">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground">
            Achetez en toute <span className="text-primary">sérénité</span>
          </h2>
          <p className="text-muted-foreground text-sm md:text-base">
            Pas de surprise. Pas d'abonnement. Juste un produit qui fonctionne.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {trustItems.map((item) => (
            <div
              key={item.label}
              className="flex flex-col items-center gap-2 p-4 rounded-xl bg-card border border-border/50"
            >
              <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center">
                <item.icon className="w-5 h-5 text-primary" />
              </div>
              <span className="font-bold text-foreground text-sm">{item.label}</span>
              <span className="text-xs text-muted-foreground">{item.sub}</span>
            </div>
          ))}
        </div>

        {/* Lifetime emphasis */}
        <div className="inline-block bg-primary/5 border-2 border-primary/20 rounded-2xl px-8 py-5">
          <p className="text-lg md:text-xl font-bold text-primary">
            {formatPrice(price)} — Accès à vie. Zéro abonnement. Point final.
          </p>
          <p className="text-sm text-muted-foreground mt-1">
            {productId === "pack-duo"
              ? "2 boîtiers, Expert Horticole, mises à jour et support inclus pour toujours."
              : "Expert Horticole, mises à jour et support inclus pour toujours."}
          </p>
        </div>

        {/* Extra reassurance lines */}
        <div className="flex flex-col items-center gap-3">
          <div className="flex items-center justify-center gap-3 text-sm text-muted-foreground">
            <Wifi className="w-4 h-4 text-primary flex-shrink-0" />
            <p>
              <span className="font-semibold text-foreground">WiFi longue portée</span> — Suivez votre jardin depuis <span className="font-semibold text-foreground">n'importe où dans le monde</span>.
            </p>
          </div>
          <div className="flex items-center justify-center gap-3 text-sm text-muted-foreground">
            <MessageCircle className="w-4 h-4 text-primary flex-shrink-0" />
            <p>
              <span className="font-semibold text-foreground">Expert Horticole intégré</span> — Posez-lui vos questions, il connaît votre jardin par cœur.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
